import { API_BASE_URL } from "./apiBaseUrl";

export interface CityDistrict {
  id: string;
  name: string;
}

class DistrictsApi {
  private baseUrl: string;

  constructor() {
    this.baseUrl = API_BASE_URL.replace(/\/+$/, "");
  }

  async getDistricts(outletId: string): Promise<CityDistrict[]> {
    const params = new URLSearchParams({ outlet_id: outletId });
    const response = await fetch(`${this.baseUrl}/GetDistricts.php?${params}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        (errorData as { message?: string }).message ||
          `HTTP ${response.status}: ${response.statusText}`
      );
    }

    const data = await response.json();
    if (!Array.isArray(data)) {
      throw new Error("Invalid districts response format");
    }

    return data.filter(
      (item): item is CityDistrict =>
        item &&
        typeof item === "object" &&
        typeof (item as CityDistrict).id === "string" &&
        typeof (item as CityDistrict).name === "string"
    );
  }
}

export const districtsApi = new DistrictsApi();
